import React from 'react';
import { Container } from './styles';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  state: string;
  isSelected: boolean;
  disabled?: boolean;
}

export const State = ({ state, isSelected, disabled = false, ...rest }: Props) => {
  return (
    <Container isSelected={isSelected} disabled={disabled} {...rest}>
      {state}
    </Container>
  );
};
